import { Button } from "@/components/ui/button";
import { ArrowRight, MessageCircle } from "@/components/Icon";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

const CTASection = () => (
  <section id="contact" className="py-20 md:py-28 bg-[#fcfcfc] text-foreground">
    <div className="container text-center max-w-2xl">
      <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#0a2933]">
        Kleding laten bedrukken?
      </h2>
      <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
        Vraag vandaag nog een vrijblijvende offerte aan of neem contact met ons op voor persoonlijk advies. Bij Magic Print betaalt u geen extra film-, zeef- of borduurkaartkosten.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Button size="lg" asChild>
          <Link
            to="/offerte"
            onClick={() => trackEvent("cta_klik", { locatie: "cta_section", doel: "offerte" })}
          >
            Gratis offerte aanvragen <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </Button>
        <Button size="lg" variant="outline" asChild>
          <Link
            to="/contact"
            onClick={() => trackEvent("cta_klik", { locatie: "cta_section", doel: "contact" })}
          >
            <MessageCircle className="mr-2 w-4 h-4" /> Contact opnemen
          </Link>
        </Button>

      </div>
    </div>
  </section>
);

export default CTASection;
